import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Main from "./Pages/Main";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main displaySlot={1} />} />
        <Route path="/display-1" element={<Main displaySlot={1} />} />
        <Route path="/display-2" element={<Main displaySlot={2} />} />
      </Routes>
    </Router>
  );
};

export default App;
